<span [tooltip]="tooltipText" [placement]="placement || 'auto'"><i *ngIf="icon" class="far {{icon}} me-1"></i>{{date | fromNow:format}}</span>
